/**
 * The licence issuer's base URL — where the website claims the paid licence a
 * person just bought (POST /paid-licence/claim, public, no sign-in).
 *
 * The same service the self-hosted box asks for its free licence. Its address
 * is declared in selfhosted/license/issuer-url.js (DEFAULT_LICENCE_ISSUER_URL);
 * this file is the website's copy because the web bundle cannot reach that
 * tree. licenceIssuer.test.js reads the sibling file when it is present and
 * fails if the two disagree (two-places tripwire) — change both together.
 */
export const LICENCE_ISSUER_URL = 'https://iutgzufrkz3n4zkfm34l4sevem0tizdf.lambda-url.ap-southeast-2.on.aws';
